import { httpClient } from '@/core/api/httpClient';
import { API_V1 } from '@/core/api/endpoints';
import type { DateRange } from '../types';
import type { RawCalendarEvent } from '../adapters/external-calendar-event.adapter';

/**
 * Unified `GET /calendar/events` feed — despite the file/hook name (kept for
 * historical reasons), it returns external-provider events (google/microsoft),
 * native TimeOff absences (`khronox`), AND the caller's own internal events
 * (`internal`, see `internal-calendar-events.service.ts` for their CRUD).
 * REQUIRES X-Tenant-Id (injected by httpClient) to determine which
 * Tenant-scoped events are included.
 */
export const externalCalendarEventsService = {
  getExternalEvents: async (
    range: DateRange,
    signal?: AbortSignal,
  ): Promise<RawCalendarEvent[]> => {
    const { data } = await httpClient.get<RawCalendarEvent[]>(`${API_V1}/calendar/events`, {
      params: { dateStart: range.start, dateEnd: range.end },
      signal,
    });
    return data;
  },
};
